<template>
  <div v-if="users && users.length > 0" class="typing-row">
    <!-- Small avatar placeholder to match message alignment -->
    <div v-if="isGroup" class="typing-avatar mr-2">
      <div
        class="d-flex align-center justify-center white--text"
        :style="`background: #90a4ae; width: 100%; height: 100%; border-radius: 50%; font-size: 11px; font-weight: 600`"
      >
        {{ firstTyperInitial }}
      </div>
    </div>

    <div class="typing-bubble">
      <!-- Sender name for group -->
      <div v-if="isGroup && typingLabel" class="typing-label mb-1">
        {{ typingLabel }}
      </div>

      <!-- Animated dots -->
      <div class="typing-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TypingIndicator',

  props: {
    users: {
      type: Array,
      default: () => []
    },
    chat: {
      type: Object,
      default: null
    }
  },

  computed: {
    isGroup() {
      return this.chat && this.chat.is_group;
    },

    firstTyper() {
      if (!this.users || this.users.length === 0) return null;
      if (!this.chat || !this.chat.users) return null;
      return this.chat.users.find(u => u.id === this.users[0]) || null;
    },

    firstTyperInitial() {
      return (this.firstTyper?.first_name || '?').charAt(0).toUpperCase();
    },

    typingLabel() {
      if (!this.users || this.users.length === 0) return '';
      if (!this.chat || !this.chat.users) return '';

      const names = this.users.map(uid => {
        const u = this.chat.users.find(u => u.id === uid);
        return u ? u.first_name : 'Someone';
      });

      if (names.length === 1) return names[0];
      if (names.length === 2) return `${names[0]} & ${names[1]}`;
      return `${names.length} people`;
    }
  }
};
</script>

<style scoped>
.typing-row {
  display: flex;
  align-items: flex-end;
  padding: 2px 12px 6px;
}

.typing-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
}

.typing-bubble {
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  border-top-left-radius: 2px;
  padding: 8px 14px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.13);
  min-width: 60px;
}

/* Left tail */
.typing-bubble::after {
  content: '';
  position: absolute;
  top: 0;
  left: -8px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 0;
  border-color: transparent #ffffff transparent transparent;
}

.typing-label {
  font-size: 12px;
  font-weight: 700;
  color: #1e88e5;
  line-height: 1.2;
  white-space: nowrap;
}

/* Animated dots */
.typing-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
}

.typing-dots span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #aaa;
  animation: typing-bounce 1.4s infinite ease-in-out;
}

.typing-dots span:nth-child(1) { animation-delay: 0s; }
.typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.typing-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes typing-bounce {
  0%, 60%, 100% {
    transform: translateY(0);
    background: #bbb;
  }
  30% {
    transform: translateY(-5px);
    background: #777;
  }
}
</style>
